import { render, staticRenderFns } from "./DoKoRestrictionSoloColor.vue?vue&type=template&id=1101cf48&scoped=true&"
import script from "./DoKoRestrictionSoloColor.vue?vue&type=script&lang=ts&"
export * from "./DoKoRestrictionSoloColor.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoRestrictionSoloColor.vue?vue&type=style&index=0&id=1101cf48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1101cf48",
  null
  
)

export default component.exports